import React from 'react';

const ChevronRight = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.3335 2.66663L10.6668 7.99996L5.3335 13.3333"
      stroke="#C6C8CC"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

export default ChevronRight;
